export default __webpack_public_path__ + "static/media/division.86424575.svg";